import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { PART_ROW_KIND_COLOR, PART_ROW_KIND_LABEL } from '../../FormChangeHistory.constants';
import { partTextStyles } from '../../FormChangeHistory.styles';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';

import { getPartNameStyles, partKindStyles, partRowStyles } from './TemplatePartRow.styles';

/** One changed part: the kind of change, the part, and where it is. */
const TemplatePartRow = ({ row }) => (
  <Box data-testid={FormChangeHistoryTestIds.PART_ROW} sx={partRowStyles}>
    <Typography
      color={PART_ROW_KIND_COLOR[row.kind]}
      data-testid={FormChangeHistoryTestIds.PART_KIND}
      sx={partKindStyles}
      variant="medium12"
    >
      {PART_ROW_KIND_LABEL[row.kind]}
    </Typography>
    <Box sx={partTextStyles}>
      <Typography
        color={row.isRemoved ? 'text.secondary' : 'text.primary'}
        data-testid={FormChangeHistoryTestIds.PART_NAME}
        sx={getPartNameStyles(row)}
        variant={row.isFieldName ? 'medium12' : 'medium14'}
      >
        {row.name}
      </Typography>
      {!!row.where && (
        <Typography
          color="text.secondary"
          data-testid={FormChangeHistoryTestIds.PART_WHERE}
          variant="regular12"
        >
          {row.where}
        </Typography>
      )}
    </Box>
  </Box>
);

TemplatePartRow.propTypes = {
  row: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    where: PropTypes.string.isRequired,
    isFieldName: PropTypes.bool.isRequired,
    isRemoved: PropTypes.bool.isRequired,
  }).isRequired,
};

export default TemplatePartRow;
